import i18n from 'i18next';

import { Chip } from '@components';
import { CellType } from '@enums';
import type { Column } from '@types';
import { capitalizeFirstLetter, getColumnSizes } from '@utils';

import { RuleStatusSelect } from '.';

export const getWAFRuleSetsTableColumns = ({ options }): Column[] => [
  {
    label: i18n.t('configuration:tables.checkBox'),
    value: 'id',
    cellType: CellType.Checkbox,
    multiLines: true,
    ...getColumnSizes(40),
  },
  {
    label: i18n.t('configuration:tables.rulesName'),
    value: 'rule_name',
    multiLines: true,
    ...getColumnSizes(150),
  },
  {
    label: i18n.t('configuration:tables.groupName'),
    value: 'group_name',
    multiLines: true,
    ...getColumnSizes(150),
  },
  {
    label: i18n.t('configuration:tables.sensitivity'),
    value: 'sensitivity',
    cellType: CellType.Custom,
    format: (value) => {
      return <Chip className="px-3 rounded-md font-medium" color="zinc" adornment={capitalizeFirstLetter(value)} />;
    },
    multiLines: true,
    ...getColumnSizes(80),
  },
  {
    label: i18n.t('configuration:tables.ruleStatus'),
    value: 'rule_status',
    cellType: CellType.Custom,
    format: (value, row) => {
      return <RuleStatusSelect value={value} rule_id={row.id} options={options} />;
    },
    multiLines: true,
    ...getColumnSizes(120),
  },
];
